import { useBranding } from "@/branding/BrandingContext";
import { getBranding } from "@/config/branding";
import type { EditionSummary } from "@/types";

import radarIaLogo from "@/assets/radar-ia-logo.svg";
import radarAdLogo from "@/assets/radar-ad-logo.svg";

import LogoCarousel from "./LogoCarousel";
import PulseHeaderActions from "./PulseHeaderActions";

interface Props {
  editions: EditionSummary[];
  selectedDate: string;
}

export default function PulseHeader({ editions, selectedDate }: Props) {
  const { brand, slug } = useBranding();
  const branding = getBranding(slug);
  const isAd = slug === "radarmkt" || /\bad\b|mkt|marketing|publicidad/i.test(brand ?? "");

  return (
    <header className="relative mx-auto w-full max-w-[1728px] px-[var(--pulse-card-mobile-gutter,1rem)] pb-6 pt-6 md:px-8 md:pb-8 md:pt-8 lg:px-10 lg:pb-12 lg:pt-10">
      <img
        src={branding.logo}
        alt="AAFF"
        className="sr-only"
        width={160}
        height={40}
      />

      <div className="pulse-header-top-controls">
        <LogoCarousel />
      </div>

      <PulseHeaderActions editions={editions} selectedDate={selectedDate} />

      <div
        className={`pulse-header-title-stack pulse-header-title-stack--figma pulse-header-title-stack--${
          isAd ? "mkt" : "ia"
        } flex flex-col items-center`}
      >
        <h1 className="pulse-header-title-heading m-0">
          <img
            src={isAd ? radarAdLogo : radarIaLogo}
            alt="Radar"
            className={`pulse-header-title-image ${
              isAd ? "pulse-header-title-image--mkt" : "pulse-header-title-image--ia"
            }`}
            width={isAd ? 601.218 : 555.32}
            height={198.329}
            decoding="async"
          />
        </h1>
      </div>
    </header>
  );
}
